import { render, staticRenderFns } from "./editResearchGroup.vue?vue&type=template&id=0a370d4d&scoped=true"
import script from "./editResearchGroup.vue?vue&type=script&lang=js"
export * from "./editResearchGroup.vue?vue&type=script&lang=js"
import style0 from "./editResearchGroup.vue?vue&type=style&index=0&id=0a370d4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a370d4d",
  null
  
)

export default component.exports